module.exports = require("babel-runtime/helpers/possibleConstructorReturn");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/possibleConstructorReturn"
// module id = 36
// module chunks = 0